import request from '@/network/http'

export function getCheckupItemList(data) {
    return request({
        url: 'Checkup/CheckupItem/getCheckupItemList',
        method: 'post',
        data
    })
}

export function getCheckupCategoryList(data) {
    return request({
        url: 'Checkup/CheckupCategory/getCheckupCategoryList',
        method: 'post',
        data
    })
}

export function saveCheckupItemInfo(data) {
    return request({
        url: 'Checkup/CheckupItem/saveCheckupItemInfo',
        method: 'post',
        data
    })
}

export function deleteCheckupItemInfo(data) {
    return request({
        url: 'Checkup/CheckupItem/deleteCheckupItemInfo',
        method: 'post',
        data
    })
}

export function getCheckupItemDetail(data) {
    return request({
        url: 'Checkup/CheckupItem/getCheckupItemDetail',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/apis/entryInformation.js